/**
 * @file 端数計算モジュール
 * @namespace ddv2.library
 */

/**
 * @module fraction
 */

export default {
  /**
   * 端数区分から算出
   * @param {Num} money 金額
   * @param {string} hasuKbn 端数区分 01:切捨,02:四捨五入,03:切上
   * @returns {Num} 算出結果
   * @example
   * const a = tax.calcTaxFromIncluded(someMoney, hasuKbn)
   */
  calcFraction: function (money, hasuKbn) {
    switch (hasuKbn) {
      case '01':
        return Math.floor(money)
      case '02':
        return Math.round(money)
      case '03':
        return Math.ceil(money)
      default:
        return null
    }
  },
  // 小数点位置の取得
  getDotPosition: function (e) {
    const strVal = String(e)
    let dotPosition = 0
    // 小数点が存在するか確認
    const a = strVal.lastIndexOf('/')
    console.log(a)
    if (strVal.lastIndexOf('.') !== -1) {
      // 小数点があったら位置を取得
      dotPosition = (strVal.length - 1) - strVal.lastIndexOf('.')
    }
    return dotPosition
  },
  // 小数点を含む計算処理
  calcSubtract: function (val1, val2) {
    // それぞれの少数点の位置を取得
    const dotPosition1 = this.getDotPosition(val1)
    const dotPosition2 = this.getDotPosition(val2)
    // 位置の値が大きい方（小数点以下の位が多い方）の位置を取得
    const max = Math.max(dotPosition1, dotPosition2)
    // 大きい方に小数の桁を合わせて文字列化し、小数点を除いて整数の値にする
    const intValue1 = parseInt((val1.toFixed(max) + '').replace('.', ''))
    const intValue2 = parseInt((val2.toFixed(max) + '').replace('.', ''))
    // 10^N の値を計算
    const diff = Math.pow(10, max)
    // 整数値で引き算した後に10^Nで割る
    return (intValue1 - intValue2) / diff
  }
}
